import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-client-partners-edit',
  templateUrl: './client-partners-edit.component.html',
  styleUrls: ['./client-partners-edit.component.scss']
})
export class ClientPartnersEditComponent implements OnInit {

  clientPartnersForm: FormGroup;
  file: any
clientLiistObj :any = {}
  constructor(private formBuilder: FormBuilder, private router: Router,
    public util: UtilService,
    public httpService: HttpServiceService, public alertService: AlertService,
    public loaderService: LoaderService) { }

  ngOnInit() {
    this.clientLiistObj = {}
   
    this.clientPartnersForm = this.formBuilder.group({
      client_list_image: ['', [Validators.required]],
      name: ['', [Validators.required]],
      description:['', [Validators.required]],

    });
  this.clientLiistObj = JSON.parse(localStorage.getItem('ClientListEditData'))
    this.clientPartnersForm.patchValue(this.clientLiistObj);
  }

  onFileSelect(event) {

    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
    }
  }

  submit(data) {

    console.log(this.clientPartnersForm.value)
    if (!this.clientPartnersForm.valid) {
			this.util.enableFromValidation(this.clientPartnersForm);
			return;
    }
    this.loaderService.showLoader('Adding Please wait ..').then(() => {
      try {
        const formData = new FormData();
        formData.append('client_list_image', this.file);

        this.httpService.postApiForImageSending(formData, `Client/client_partner_update_data?name=${this.clientPartnersForm.get('name').value}&id=${this.clientLiistObj.id}&description=${this.clientPartnersForm.get('description').value}`).subscribe((res) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('success', 'Successfully added', 'Okay');
            this.router.navigate(['/client-partner-list'])
          } else {
            this.alertService.presentAlert('Error', res["error"]["success"], 'Okay');
          }
        }, (err) => {

          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
        });
      } catch (e) {
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error', 'Something went wrong please try again', 'Okay');
      }
    })

  }


}
